export const API_CONFIG = {
  BASE_URL: `${process.env.REACT_APP_API_BASE_URI}/Prod`,
  ENDPOINTS: {
    APPOINTMENT: '/appointments/${apptId}',
    APPOINTMENTS: '/appointments',
    SALONS: '/salons',
    SALON_STAFF: '/salons/${salonId}/staff',
    SERVICES: '/services',
    SALON_SERVICES: '/salon-services/${salonServiceId}',
    STAFF_SERVICES: '/staff-services/${staffServiceId}',
    SERVICES_BY_SALON: '/salons/${salonId}/services',
    STAFF: '/staff',
    STAFF_BY_ID: '/staff/${staffId}',
    INVITE_STAFF: '/staff/invite',
    TIME_BLOCKS: '/timeoff',
    TIME_BLOCKS_BY_SALON: '/salons/${salonId}/timeoff',
    DELETE_TIME_BLOCKS: '/timeoff/${timeBlockId}/${appliesTo}',
    GET_CHECKOUT_URL: '/get-checkout-url',
    CREATE_STRIPE_CONNECT_ACCOUNT: '/create-stripe-connect-account',
    GET_STRIPE_CONNECT_ACCOUNT_LINK: '/get-stripe-connect-account-link',
    INITIALIZE_STRIPE_CONNECT_ACCOUNT_SESSION: '/create-stripe-connect-account-session',
    REGISTER_STRIPE_TERMINAL_DEVICE: '/register-stripe-terminal-device',
    GET_STRIPE_TERMINAL_DEVICE: '/get-stripe-terminal-device',
    CREATE_PAYMENT_INTENT: '/create-payment-intent',
    UPDATE_PAYMENT_INTENT: '/update-payment-intent',
    PROCESS_PAYMENT: '/process-payment',
    POLL_STRIPE_PAYMENT_STATUS: '/poll-stripe-payment-status',
    SIMULATE_PAYMENT: '/simulate-payment',
    CANCEL_PAYMENT_INTENT: '/cancel-payment-intent',
    SALON_CLIENTS: '/salons/${salonId}/clients',
    CLIENTS_BY_ID: '/clients/${clientId}',
    CLIENTS: '/clients',
    MARKETING_TEMPLATE_VARIABLES: '/marketing/templated-values/${salonId}',
    MARKETING_COMPLIANCE_MESSAGES: '/marketing/compliance-messages',
    MARKETING_TEMPLATES: '/marketing/templates',
    MARKETING_CHECK_COMPLIANCE: '/marketing/check-compliance',
    MARKETING_CAMPAIGNS: '/marketing/campaigns',
    SALON_CAMPAIGNS: '/salons/${salonId}/campaigns',
    MARKETING_CAMPAIGN_BY_ID: '/marketing/campaigns/${campaignId}',
    UPDATE_CAMPAIGN: '/marketing/campaigns',
  }
};

// Helper function to construct URLs
export const getApiUrl = (endpoint, queryParams = '', pathParams = null) => {
  if (pathParams) {
    const matches = endpoint.matchAll(/\${(\w+)}/g);
    let processedEndpoint = endpoint;
    for (const match of matches) {
      if (pathParams[match[1]]) {
        processedEndpoint = processedEndpoint.replace(match[0], pathParams[match[1]]);
      }
    }
    
    endpoint = processedEndpoint;
  }

  queryParams = queryParams ? `?${queryParams}` : '';
  return `${API_CONFIG.BASE_URL}${endpoint}${queryParams}`;
};